import 'angular-load';

export const StripModule = angular
  .module('stripe', ['angularLoad'])
  .service('StripeService', StripeService);

const STRIPE_URL = 'https://js.stripe.com/v2/';
const ERRORS = {
  invalid_expiry_year: 'Please enter a valid expiration year.',
  invalid_expiry_month: 'Please enter a valid expiration month.',
  incorrect_number: 'Please enter a valid card number.',
  invalid_cvc: 'Please enter a valid card CVC.',
  default:
    'Something went wrong. Please try again later or try different details.',
};

function StripeService($q, $window, angularLoad) {
  'ngInject';
  let $stripe;

  this.init = key => {
    return angularLoad
      .loadScript(STRIPE_URL)
      .then(setStripe)
      .then(() => setPublishableKey(key))
      .then(() => this);
  };

  this.card = card => {
    return $q((resolve, reject) => {
      $stripe.card.createToken(card, handleResponse(resolve, reject));
    });
  };

  function setStripe() {
    $stripe = $window.Stripe;
  }

  function setPublishableKey(key) {
    return $q.resolve($stripe.setPublishableKey(key));
  }

  function handleResponse(resolve, reject) {
    return function(status, response) {
      let error = response.error;

      if (error) {
        // Overwrite the stripe error message with our own, original message for 'number'
        // is 'Your card number is incorrect.' Ours are a little more polite...
        // TODO: Evaluate if we still want to do this moving forward
        error.message = ERRORS[error.code] || ERRORS.default;

        // Extending Error so we retain the type, param and code properties along with message
        // error response = {
        //  message:  'Your card number is incorrect.',
        //  type:     'card_error',
        //  param:    'number',
        //  code:     'incorrect_number'
        // }
        reject(angular.merge(new Error(), error));
      } else {
        resolve(response);
      }
    };
  }
}
